// Generated by CoffeeScript 1.11.1
(function() {
  var Thumbnail;

  module.exports = Thumbnail = (function() {
    Thumbnail.prototype.id = 1036;

    Thumbnail.prototype.name = 'thumbnail';

    function Thumbnail(resource) {
      this.resource = resource;
      this.file = this.resource.file;
    }

    Thumbnail.prototype.parse = function() {
      var binaryString;
      this.format = this.file.readString(4);
      this.width = this.file.readInt();
      this.height = this.file.readInt();
      this.widthBytes = this.file.readInt();
      this.totalSize = this.file.readInt();
      this.compressedSize = this.file.readInt();
      this.bitsPerPixel = this.file.readShort();
      this.numberOfPlanes = this.file.readShort();
      this.jfif = this.file.read(this.compressedSize);
      binaryString = String.fromCharCode.apply(null, this.jfif);
      return this.url = 'data:image/jpeg;base64,' + btoa(binaryString);
    };

    return Thumbnail;

  })();

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/resources/thumbnail.js
// module id = 101
// module chunks = 0